import { CheckCircle2, Clock, CircleDot, Eye, FileText, Ban, Flag } from "lucide-react";

export const PIPELINE_API = location.origin === "https://nextgen-dev.learningmate.co"
    ? "https://api-genai-dev.learningmate.co/agentpipeline/api/v1"
    : location.origin === "https://kadalcms.kadal.ai"
      ? "https://api.kadal.ai/agentpipeline/api/v1"
      : `${location.origin}/api/v1`;

export const API = PIPELINE_API;

export const STATUS_COLUMNS = ["todo", "draft", "in_review", "done", "published"];
export const STATUS_LABELS = { todo: "To Do", draft: "Draft", in_review: "In Review", done: "Done", published: "Published" };
export const STATUS_COLORS = {
  todo: { bg: "bg-gray-100", text: "text-foreground/50", dot: "bg-gray-300", border: "border-gray-200" },
  draft: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-400", border: "border-amber-200" },
  in_review: { bg: "bg-blue-50", text: "text-[#014d7d]", dot: "bg-[#014d7d]", border: "border-blue-200" },
  done: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", border: "border-emerald-200" },
  published: { bg: "bg-purple-50", text: "text-purple-700", dot: "bg-purple-500", border: "border-purple-200" },
};
export const STAGE_STATUS = {
  completed: { bg: "bg-emerald-500", text: "text-emerald-700", light: "bg-emerald-50", border: "border-emerald-200" },
  in_progress: { bg: "bg-[#014d7d]", text: "text-[#014d7d]", light: "bg-blue-50", border: "border-blue-200" },
  pending: { bg: "bg-gray-200", text: "text-foreground/50", light: "bg-gray-50", border: "border-border/40" },
};
export const TASK_STATUS_ICON = {
  completed: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />,
  done: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />,
  in_progress: <CircleDot className="w-3.5 h-3.5 text-[#014d7d]" />,
  in_review: <Eye className="w-3.5 h-3.5 text-blue-500" />,
  pending: <Clock className="w-3.5 h-3.5 text-foreground/50" />,
  todo: <Clock className="w-3.5 h-3.5 text-foreground/50" />,
  draft: <FileText className="w-3.5 h-3.5 text-amber-500" />,
  blocked: <Ban className="w-3.5 h-3.5 text-red-500" />,
  published: <Flag className="w-3.5 h-3.5 text-purple-500" />,
};
